// extracted by mini-css-extract-plugin
export default {"cta":"sJ-z","disabled":"tJ-z"};